var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',[(_vm.showBack)?_c('li',{staticClass:"back",on:{"click":_vm._backPlay}},[_c('i')]):_vm._e(),(_vm.barrageInfo.status === 1)?_c('li',{staticClass:"barrage",class:{ 'z-active': _vm.showBarrage },attrs:{"id":"barrage-skin"},on:{"click":_vm._setBarrage}},[_c('i',[_vm._v("弹")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }